import { useRef, useState, useEffect } from 'react'
import { useFrame } from '@react-three/fiber'
import { Outlines } from '@react-three/drei'

export default function Clouds({
    cloud,
    cloudMaterial,
    maxCloudDistanceWidth,
    totalClouds,
    cloudSeparationY,
    startExperiencesCameraUnitsOffset
}) {
    const cloudRefs = []
    for (var i = 0; i < totalClouds; i++) {
        cloudRefs.push(useRef())
    }

    const [cloudPositions, setCloudPositions] = useState([])
    const [cloudRotations, setCloudRotations] = useState([])

    useEffect(() => {
        const randomPositions = []
        const randomRotations = []
        const possibleInitialMinPositionX = -maxCloudDistanceWidth * 0.9
        const possibleInitialMaxPositionX = maxCloudDistanceWidth * 0.9
        const minDiff = maxCloudDistanceWidth * 0.3
        let lastRandomPositionX = 0.0
        for (let i = 0; i < totalClouds; i++) {
            let nextRandomPositionX = (possibleInitialMaxPositionX - possibleInitialMinPositionX) * Math.random() + possibleInitialMinPositionX
            if (Math.abs(nextRandomPositionX - lastRandomPositionX) < minDiff) {
                nextRandomPositionX = lastRandomPositionX + minDiff
            }
            randomPositions.push(nextRandomPositionX)
            randomRotations.push(Math.random() * Math.PI * 2.0)
            lastRandomPositionX = nextRandomPositionX
        }
        setCloudPositions(randomPositions)
        setCloudRotations(randomRotations)
    }, [])

    useFrame((_state, delta) => {
        for (var i = 0; i < cloudRefs.length; i++) {
            const cloudRef = cloudRefs[i].current
            cloudRef.rotation.y += delta * 0.1
            cloudRef.position.x += delta * 0.2

            if (cloudRef.position.x > maxCloudDistanceWidth) {
                cloudRef.position.x = -maxCloudDistanceWidth
            }

            // update cloudPositions
            cloudPositions[i] = cloudRef.position.x
            cloudRotations[i] = cloudRef.rotation.y
        }
    })

    return (
        <group name={"clouds"}>
            {Array.from({ length: totalClouds }, (_, i) => (
                <primitive
                    key={"cloud_" + i}
                    ref={cloudRefs[i]}
                    object={cloud.clone()}
                    material={cloudMaterial}
                    scale={[0.2, 0.2, 0.2]}
                    position={[
                        cloudPositions[i],
                        -i * cloudSeparationY - startExperiencesCameraUnitsOffset - 2.5,
                        -3
                    ]}
                    rotation={[
                        0,
                        cloudRotations[i],
                        0
                    ]}
                >
                    <Outlines
                        thickness={1.0}
                    />
                </primitive>
            ))}
        </group>
    )
} 